import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import './Accordion.scss';
import Icon from '../../components/Icon/Icon';

interface AccordionProps {
  children: React.ReactNode,
  /**
   * Determines title on accordion
   */
  title: string | React.ReactNode,
  /**
   * Override initial open status
   */
  defaultOpen?: boolean,
  /**
   * Pass a link if you want to redirect to page
   */
  link?: string,
  /**
   * Total number to show on the right side
   */
  totalSelected?: number,
  /**
   * Force status with true or false
   */
  open?: boolean
  totalMarkets?: number,
  onClickMarkets?: () => void
}

function ConditionalWrapper({ condition, wrapper, children }) {
  return condition ? wrapper(children) : children;
}

function Accordion({ children,
  title,
  link,
  defaultOpen = false,
  totalSelected = 0,
  open = false,
  totalMarkets=0,
  onClickMarkets= () => {} }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);


  const handleToggle = () => {
    setIsOpen(!isOpen);
  };


  useEffect(() => {
    setIsOpen(open);
  }, [open]);


  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);


  return (
    <div
      className={
        classNames({
          'accordion' : true,
          'accordion--open': isOpen
        })
      }
    >
      <ConditionalWrapper
        condition={ link }
        wrapper={ children => <Link to={ link }>{ children }</Link> }
      >
        <div
          onClick={ handleToggle }
          className="accordion__header"
        >
          <span className="accordion__title">{ title }
          </span>
          { totalMarkets > 0 && <span className="accordion__total-markets" onClick={ onClickMarkets }>  { `+ ${ totalMarkets }` }</span> }
          { totalSelected > 0 && <div className="accordion__total">{ totalSelected }</div> }
          <Icon
            className="accordion__icon"
            icon="dropdownArrow"
          />
        </div>
      </ConditionalWrapper>
      {
        isOpen && (
          <div className="accordion__body">
            { children }
          </div>
        )
      }
    </div>
  );
}

export default Accordion;
